import { Routes } from '@angular/router';
import { Authority } from '@app/shared/utils/enums';
import { Kevlar2ConfigComponent } from '@app/features/kevlar2-config/kevlar2-config.component';

export const kevlar2ConfigRoutes: Routes = [
    {
        path: 'kevlar2-config',
        children: [
            {
                path: '',
                component: Kevlar2ConfigComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                }
            }
        ]
    }
]